<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'MAINTENANCES.TABS.FORMS.FORM_DETAILS.TITLE' | translate }}
    </h2>

    <button
      class="field-dialog__header__close mat-icon-button field-dialog__close-button"
      mat-icon-button
      (click)="matDialogRef.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <form class="field-dialog__content__scroll p-24" fxLayout="column" fusePerfectScrollbar>
    <span class="field-dialog__form-title">{{ formTitle }}</span>

    <div class="field-dialog__form-questions" *ngFor="let question of questionAnswers">
      <span class="field-dialog__form-questions__question-title">
        {{ question.title }}<span *ngIf="question.required">*</span>
      </span>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'shortAnswer'"
      >
        <input class="field-dialog__answer" matInput [value]="question.answer" disabled />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer date-hour"
        appearance="outline"
        floatLabel="never"
        fxFlex="100"
        *ngIf="question.type === 'date'"
      >
        <input matInput [value]="question.answer | date: 'dd/MM/yyyy'" disabled />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'numeric'"
      >
        <input matInput [value]="question.answer" disabled />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'currency'"
      >
        <input
          matInput
          [(ngModel)]="question.answer"
          [value]="question.answer"
          mask="separator.2"
          [name]="question.id"
          [thousandSeparator]="'.'"
          [decimalMarker]="','"
          prefix="R$ "
          disabled
        />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'email'"
      >
        <input matInput [value]="question.answer" disabled />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'phone'"
      >
        <input
          matInput
          [(ngModel)]="question.answer"
          [value]="question.answer"
          [name]="question.id"
          mask="(00) 0000-0000||(00) 0 0000-0000"
          disabled
        />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'document'"
      >
        <input
          matInput
          [(ngModel)]="question.answer"
          [value]="question.answer"
          [name]="question.id"
          mask="AAA.AAA.AAA-AA9||AA.AAA.AAA/AAAA-AA"
          disabled
        />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer date-hour"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'hour'"
      >
        <input matInput [value]="question.answer" disabled />
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer textarea-wrapper"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'paragraph'"
      >
        <textarea matInput matTextareaAutosize [value]="question.answer" disabled></textarea>
        <span class="remaning">({{ question.answer ? question.answer.length : 0 }}/2000)</span>
      </mat-form-field>

      <mat-form-field
        class="field-dialog__answer"
        appearance="outline"
        fxFlex="100"
        floatLabel="never"
        *ngIf="question.type === 'dropdown'"
      >
        <input matInput [value]="question.answer" disabled />
      </mat-form-field>

      <mat-radio-group
        fxLayout="column"
        *ngIf="question.type === 'multipleChoice'"
        class="field-dialog__answer mat-form-field margin-top"
      >
        <mat-radio-button
          disabled
          matInput
          class="example-radio-button"
          *ngFor="let option of question.options; let i = index"
          [checked]="option.value == question.answer"
          [value]="i"
        >
          {{ option.value }}
        </mat-radio-button>
      </mat-radio-group>

      <div
        fxLayout="column"
        *ngIf="question.type === 'checkboxes'"
        class="field-dialog__answer mat-form-field margin-top"
      >
        <mat-checkbox
          matInput
          *ngFor="let option of question.options; let i = index"
          [checked]="isChecked(question.answer, option.value)"
          [disabled]="true"
        >
          {{ option.value }}
        </mat-checkbox>
      </div>

      <div
        *ngIf="question.type === 'signature'"
        fxLayout="column"
        class="field-dialog__answer__signature mat-form-field margin-top"
        fxLayoutAlign="center center"
      >
        <img [src]="question.answer" *ngIf="question.answer" />
        <span *ngIf="!question.answer" class="field-dialog__answer__no-data">
          {{ 'MAINTENANCES.TABS.FORMS.FORM_DETAILS.NO_SIGNATURE' | translate }}
        </span>
      </div>

      <div
        *ngIf="question.type === 'picture' || question.type === 'multiplePicture'"
        class="field-dialog__answer__pictures mat-form-field margin-top"
        fxLayout="row"
        fxLayoutAlign="start start"
        fxLayoutGap="20.5px"
      >
        <ng-container *ngFor="let pictureUrl of splitPicturesUrl(question.answer)">
          <a *ngIf="pictureUrl" class="field-dialog__answer__pictures__picture" [href]="pictureUrl" target="_blank">
            <img [src]="pictureUrl" />
            <span>
              <mat-icon>visibility</mat-icon>
            </span>
          </a>
        </ng-container>

        <span *ngIf="!question.answer" class="field-dialog__answer__no-data">
          {{ 'MAINTENANCES.TABS.FORMS.FORM_DETAILS.NO_PICTURE' | translate }}
        </span>
      </div>
    </div>
  </form>
</div>
